import type { AccountingBook } from '../../lib/types/finance.js';

/** Stored choice meaning «همه دفاتر» (only the journal list can show every book at once). */
export const ALL_BOOKS = 'all';

export function isStatutoryBook(book: AccountingBook): boolean {
  return book.isStatutory || book.code === 'STATUTORY';
}

/**
 * The book a finance page runs against. `stored` is the remembered choice (a
 * book id or code, or `ALL_BOOKS`); with no usable choice the statutory book is
 * used (D-022: reports default to it), and «all» also reports against it.
 */
export function resolveBook(
  books: readonly AccountingBook[],
  stored: string | null,
): { readonly book: AccountingBook | null; readonly isAll: boolean } {
  const statutory = books.find(isStatutoryBook) ?? books[0] ?? null;
  if (stored === ALL_BOOKS) return { book: statutory, isAll: true };
  const chosen = books.find((b) => b.bookId === stored || b.code === stored);
  return { book: chosen ?? statutory, isAll: false };
}

/**
 * Moadian and VAT filing work on the statutory book only (D-022 DEC-4):
 * unavailable only while a non-statutory book is the one chosen.
 */
export function statutoryFeaturesAvailable(book: AccountingBook | null, isAll: boolean): boolean {
  return isAll || book === null || isStatutoryBook(book);
}
